import { z } from 'zod';

/**
 * Response shape of GET /admin/stats.
 * Mirrors `buildStatsResponse()` in apps/api/src/routes/admin/stats.ts —
 * keep in sync with the actual route implementation, not with historical specs.
 */
export const adminStatsResponseSchema = z.object({
  users: z.object({
    total: z.number().int(),
    onboarded: z.number().int(),
    new_7d: z.number().int(),
    new_30d: z.number().int(),
    referred: z.number().int(),
  }),
  money: z.object({
    paying_users: z.number().int(),
    paying_share: z.number(),
    payments_count: z.number().int(),
    // ::float8 cast in SQL (accumulated revenue can exceed int4 range), not an integer.
    revenue_kzt: z.number(),
    repeat_buyers: z.number().int(),
  }),
  usage: z.object({
    generations_total: z.number().int(),
    generations_7d: z.number().int(),
    users_with_generation: z.number().int(),
    generation_conversion: z.number(),
  }),
  llm: z.object({
    total_spent_usd: z.number().nullable(),
    balance_usd: z.number().nullable(),
    spent_7d_usd: z.number(),
    spent_30d_usd: z.number(),
    avg_per_generation_30d_usd: z.number().nullable(),
  }),
});

export type AdminStatsResponse = z.infer<typeof adminStatsResponseSchema>;
